import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {CODE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Chassis License Plate Number text field.
 * Uppercases and sanitizes input. This field is never required across any asset type.
 */
const ChassisLicensePlateField: React.FC<Omit<CheckInFieldProps, 'required'>> = ({value, onValueChange, error}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase());
    onValueChange('chassisLicensePlateNumber', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="chassisLicensePlateNumber"
      name="chassisLicensePlateNumber"
      label="Chassis License Plate Number"
      value={value}
      onChange={handleChange}
      placeholder="Enter the chassis license plate number"
      variant="standard"
      fullWidth
      error={!!error}
      helperText={error}
      inputProps={{...CODE_INPUT_PROPS, 'aria-label': 'Chassis License Plate Number'}}
    />
  );
};

export default ChassisLicensePlateField;

